import React from 'react';

import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

import { Button } from '~/techstyle-shared/react-components';
import { FormattedMessage } from '~/techstyle-shared/react-intl';

import { identifyUserOnAction } from '../../actions';

const StyledButton = styled(Button)`
  cursor: pointer;
  & > span {
    font-weight: inherit;
  }
`;

export default function LogOutButton({
  onClick,
  icon,
  trackAccountSegmentEvents = () => {},
  children,
  ...props
}) {
  const dispatch = useDispatch();

  const handleClick = async () => {
    await trackAccountSegmentEvents();
    dispatch(identifyUserOnAction());
    onClick();
  };

  const Icon = () => icon || null;

  return (
    <StyledButton
      variant="unstyled"
      {...props}
      onClick={handleClick}
      data-autotag="logout-btn"
    >
      <Icon />
      {children || (
        <FormattedMessage defaultMessage="Log out" id="global_cta.log_out" />
      )}
    </StyledButton>
  );
}

LogOutButton.propTypes = {
  children: PropTypes.element,
  icon: PropTypes.node,
  onClick: PropTypes.func.isRequired,
  trackAccountSegmentEvents: PropTypes.func,
};
